import React from 'react'
import { useParams } from 'react-router'
import StatisticCard from './StatisticCard'
import { useFetchEstimateRemainingReviewTimeQuery } from '../../../../../../store/apis/analytics.api'
import useTotalReviewProgress from '../../../../components/assignment-header/question-progress/useTotalReviewProgress'

const AverageTimePerReviewCard = () => {
    const { token } = useParams()
    const { data, isLoading, error } = useFetchEstimateRemainingReviewTimeQuery({ token })
    const { reviewed } = useTotalReviewProgress()

    const getAdditionalContentByTime = (timeInSeconds) => {
        if (timeInSeconds < 30) {
            return 'Lightning fast! ⚡'
        } else if (timeInSeconds < 60) {
            return 'Great pace! 🚀'
        } else if (timeInSeconds < 120) {
            return 'Steady rhythm 🎯'
        } else if (timeInSeconds < 300) {
            return 'Thorough approach 🔍'
        } else {
            return 'Take your time 🐢'
        }
    }

    const getDisplayValues = () => {
        if (!data || data.averageReviewTime == null) {
            if (reviewed === 0) {
                return {
                    value: 'N/A',
                    suffix: '',
                    additionalContent: 'Review some items first to see your average time ⏱️'
                }
            } else {
                return {
                    value: 'N/A',
                    suffix: '',
                    additionalContent: "We couldn't calculate your average time yet 🤔"
                }
            }
        }

        const timeInSeconds = Math.round(data.averageReviewTime / 1000)
        return {
            value: timeInSeconds,
            suffix: 's',
            additionalContent: getAdditionalContentByTime(timeInSeconds)
        }
    }

    const { value, suffix, additionalContent } = getDisplayValues()

    return (
        <StatisticCard
            title="Avg Time per Review"
            value={value}
            suffix={suffix}
            additionalContent={additionalContent}
            loading={isLoading}
            error={error}
        />
    )
}

export default AverageTimePerReviewCard 